/**
 * Floor Plan Configuration DOM Component
 *
 * Renders the Floor Plan Configuration content panel.
 * Placeholder content — to be updated with actual configuration options.
 *
 * @module nativeInteractiveSiteMap/components/floorPlanConfiguration.dom
 */

import fastdom from 'fastdom';
import { viewFloorPlanIconSvg } from 'constants/svg-assets';

/**
 * Creates the Floor Plan Configuration content component
 * @returns {{ getElement: Function, getEmptyStateElement: Function, hide: Function, show: Function, remove: Function }}
 */
export default function createFloorPlanConfigurationDom() {
  const state = { root: null, emptyState: null };

  function initializeDom() {
    state.root = document.createElement('div');
    state.root.className = [
      'nhs-c-native-interactive-site-map__content',
      'nhs-mq-native-interactive-site-map__content-medium',
      'nhs-mq-native-interactive-site-map__content-large',
      'nhs-u-padding--0-500',
      'nhs-u-flex-column',
      'nhs-u-gap--500',
      'nhs-u-grow--1',
    ].join(' ');

    state.root.innerHTML = `
      <div class="nhs-c-native-interactive-site-map__floor-plan-configuration-empty"
           data-floor-plan-configuration-empty
           data-qa="native_ism_floor_plan_configuration_empty">
        ${viewFloorPlanIconSvg}
        <h4 class="nhs-o-typography--sans-body-1-small-book">No configurations available</h4>
        <p class="nhs-o-typography--sans-label-1-extra-extra-small-regular">Configurations are not available for this floor plan.</p>
      </div>
    `;
    state.emptyState = state.root.querySelector('[data-floor-plan-configuration-empty]');
  }

  initializeDom();

  return {
    getElement() {
      return state.root;
    },

    // The empty-state block is centered as a group (icon/title/copy — see
    // .nhs-c-native-interactive-site-map__floor-plan-configuration-empty's flex centering).
    // Callers that need to add mobile-only content directly under the copy (e.g.
    // floorPlanDetail.plugin.js's "View Floor Plan" CTA) append into this element instead of
    // getElement(), so it centers as part of the same group rather than sitting outside it.
    getEmptyStateElement() {
      return state.emptyState;
    },

    hide() {
      fastdom.mutate(() => {
        state.root.hidden = true;
      });
    },

    show() {
      fastdom.mutate(() => {
        state.root.hidden = false;
      });
    },

    remove() {
      fastdom.mutate(() => {
        state.root?.remove();
        state.root = null;
      });
    },
  };
}
